import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.request-center.list', {
        url: '/list',
        component: 'requestCenterList',
        resolve: {},
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/list/request-center-list.state.js